// ── Constants & Configuration ────────────────────────────────────
// All static configuration, regex patterns, and enum-like data.

export const ASIN_REGEX = /^[A-Z0-9]{10}$/;

export const PHASE_ORDER = ["scraping", "building_keywords"];

export const PHASE_LABELS = {
  scraping: "竞品抓取",
  building_keywords: "词库构建",
  completed: "分析完成",
};

export const STATUS_LABELS = {
  running: "进行中",
  completed: "分析完成",
  failed: "失败",
};

export const ALGORITHM_KEYS = {
  a9: "A9 算法",
  rufus: "Rufus 算法",
  cosmo: "COSMO 算法",
};

export const PRIORITY_COLORS = {
  high: "var(--danger)",
  medium: "var(--accent)",
  low: "var(--muted)",
};

export const DIMENSION_LABELS = {
  keywords: "关键词",
  bullets: "五点",
  description: "描述",
  backend: "后台",
};

export const STEP_LABELS = {
  1: { title: "选择商品源", subtitle: "输入 ASIN 或链接" },
  2: { title: "关键词词库", subtitle: "AI 分析产品特征" },
  3: { title: "Listing 生成", subtitle: "标题 / 亮点 / 五点" },
  4: { title: "AI 优化中心", subtitle: "合规 / 评分 / 改稿聚合" },
};

export const STEP_PANELS = {
  1: "step-input",
  2: "step-keywords",
  3: "step-generation",
  4: "optimization-center-panel",
};

export const MAX_SEARCH_TERMS_BYTES = 250;
